import concordeCookie from '@wetransfer/transfer/modules/concorde-cookie';

import { POPOVER_DISMISSED_FOREVER_COOKIE_KEY } from './constants';
import { FeaturePromptEvent } from './types';

export const preventDefault = (event: Event): void => event.preventDefault();

export const setWasPopoverDismissedCookie = (): void =>
  concordeCookie.set(POPOVER_DISMISSED_FOREVER_COOKIE_KEY, true, {
    days: 365,
  });

export const createFeaturePromptEvent = (
  action: 'Confirm' | 'Dismiss' | 'Shown',
  component: 'Popover' | 'Tooltip'
): FeaturePromptEvent => ({
  action: 'Feature Prompt',
  additionalProperties: {
    Action: action,
    Feature: 'Upsell: Custom Wallpaper',
    Component: component,
    Context: 'Transfer Window',
  },
});
